
import { supabase } from './supabaseClient';
import { DataSource } from '../types';

export const fetchDataSources = async () => {
  const { data, error } = await supabase
    .from('data_sources')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching data sources:', error);
    throw error;
  }
  return data as DataSource[];
};

export const createDataSource = async (
  name: string,
  type: string,
  website_url?: string
) => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("User not authenticated");

  const { data, error } = await supabase
    .from('data_sources')
    .insert({
      name,
      type,
      website_url,
      credibility: 80, // Default credibility score
      created_by: user.id
    })
    .select()
    .single();

  if (error) {
    console.error('Error creating data source:', error);
    throw error;
  }
  return data as DataSource;
};

export const updateDataSource = async (id: string, updates: Partial<DataSource>) => {
  const { data, error } = await supabase
    .from('data_sources')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as DataSource;
};

export const deleteDataSource = async (id: string) => {
  // 1. Check for usage in public_data_points
  const { count, error: countError } = await supabase
    .from('public_data_points')
    .select('*', { count: 'exact', head: true })
    .eq('source_id', id); // Corrected from data_source_id

  if (countError) throw countError;

  if (count && count > 0) {
    throw new Error(`Cannot delete: This source is linked to ${count} data point(s).`);
  }

  // 2. Delete if safe
  const { error } = await supabase
    .from('data_sources')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting data source:', error);
    throw error;
  }
};
